import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestLabDetails } from '../../../store/lab-details/LabDetailsActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hostTitle } from '../../../config/ui';

class LabDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: 25, page: 0, pages: -1, search: '', sorted: [] };
    this.handleSearch = this.handleSearch.bind(this);
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getLabDetails({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
      })
      .then((response) =>
        this.setState({
          pages: response.payload.data.total
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  render() {
    const { data } = this.props;
    return (
      <div id="content">
        <Helmet title={`Lab Details – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Resource Library', 'Lab Details']}
              icon="fa fa-fw fa-book"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>Lab Order Summary List</h2>
                </header>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'Lab Test Name',
                          id: 'testName',
                          accessor: 'testName',
                        },
                        {
                          Header: 'Count of Orders',
                          id: 'orderCount',
                          accessor: 'orderCount',
                        },
                        {
                          Header: 'Pick List Status',
                          id: 'pickList',
                          accessor: 'pickList',
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.labdetails,
    tenantId: state.currentUser.queryParams.tenantId,
  }),
  (dispatch) => ({
    getLabDetails: (params) => dispatch(requestLabDetails(params)),
  }),
)(LabDetails);



// WEBPACK FOOTER //
// ./src/routes/resource-library/containers/LabDetails.js